var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.811156,0,0,0.811156,5.36787,22.7926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-9.351C-0.487,-9.351 -0.885,-8.955 -0.885,-8.467L-0.885,5.154C-0.885,5.642 -0.487,6.038 0,6.038L31.146,6.038C31.634,6.038 32.031,5.642 32.031,5.154L32.031,-14.504C32.031,-14.992 31.634,-15.389 31.146,-15.389L0,-15.389C-0.377,-15.389 -0.713,-15.149 -0.836,-14.792C-0.959,-14.435 -0.842,-14.04 -0.545,-13.808L15.029,-1.638C15.339,-1.397 15.762,-1.384 16.083,-1.612L26.922,-9.249C27.32,-9.53 27.416,-10.083 27.135,-10.482C26.855,-10.88 26.302,-10.976 25.904,-10.695L15.6,-3.435L2.567,-13.621L30.263,-13.621L30.263,4.271L0.884,4.271L0.884,-8.467C0.884,-8.955 0.488,-9.351 0,-9.351",
    style: {
      fill: "rgb(128,128,128)",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mailLogo.293fa466.svg";
export { ForwardRef as ReactComponent };